import React from 'react';
import Layout from '../components/layout';
import Pad from '../components/pad';
import SEO from '../components/seo';

function Terms() {
  const title = 'KidGenius | Terms of Service';
  const desc =
    'KidGenius terms of service for our childcare management software website.';

  return (
    <Layout>
      <SEO title={title} description={desc} />
      <Pad>
        <div className="flex flex-col justify-center items-center">
          <h1 className="text-4xl font-brand-bold">Terms of Service</h1>
          <h2 className="font-bold">
            These Terms were last updated on 20-Dec-2016, and are effective as
            of 21-Dec-2016.
          </h2>
          <div className="w-2/3 sm:w-3/4 pt-8">
            <p className="pt-2">
              By using the "www.trykidgenius.com" web sites ("The Service", "Our Site"), or
              any services of KidGenius ("We", "Us", "The Company"), you are
              agreeing to be bound by the following terms and conditions ("Terms
              of Service"). IF YOU ARE ENTERING INTO THIS AGREEMENT ON BEHALF OF
              A COMPANY OR OTHER LEGAL ENTITY, YOU REPRESENT THAT YOU HAVE THE
              AUTHORITY TO BIND SUCH ENTITY, ITS AFFILIATES AND ALL USERS WHO
              ACCESS OUR SERVICES THROUGH YOUR ACCOUNT TO THESE TERMS AND
              CONDITIONS, IN WHICH CASE THE TERMS "YOU" OR "YOUR" SHALL REFER TO
              SUCH ENTITY, ITS AFFILIATES AND USERS ASSOCIATED WITH IT. IF YOU
              DO NOT HAVE SUCH AUTHORITY, OR IF YOU DO NOT AGREE WITH THESE
              TERMS AND CONDITIONS, YOU MUST NOT ACCEPT THIS AGREEMENT AND MAY
              NOT USE THE SERVICES.
            </p>
            <p className="pt-4">
              If We make material changes to these Terms, We will notify you by
              posting a notice on Our Site before the changes are effective. Any
              new features that augment or enhance the current Service,
              including the release of new tools and resources, shall be subject
              to the Terms of Service. Continued use of The Service after any
              such changes shall constitute your consent to such changes. You
              can review the most current version of the Terms of Service at any
              time at: "https://kidgenius.com/terms" for KidGenius              
            </p>
            <p className="pt-4">
              Violation of any of the terms below will result in the termination
              of your Account. While We prohibit such conduct and Content on The
              Service, you understand and agree that We cannot be responsible
              for the Content posted on The Service and you nonetheless may be
              exposed to such materials. You agree to use The Service at your
              own risk.
            </p>
            <h3 className="text-2xl pt-6">Account Terms</h3>
            <ul className="pt-4 pl-6 list-decimal">
              <li>You must be 13 years or older to use this Service.</li>
              <li>
                You must be a human. Accounts registered by "bots" or other
                automated methods are not permitted.
              </li>
              <li>
                You must provide a valid email address, and any other
                information requested in order to complete the signup process.
              </li>
              <li>
                You are responsible for maintaining the security of your account
                and password. We cannot and will not be liable for any loss or
                damage from your failure to comply with this security
                obligation.
              </li>
              <li>
                You are responsible for all Content posted and activity that
                occurs under your account (even when Content is posted by others
                who have accounts under your account).
              </li>
              <li>
                You may not use The Service for any illegal or unauthorized
                purpose. You must not, in the use of The Service, violate any
                laws in your jurisdiction (including but not limited to
                copyright or trademark laws).
              </li>
            </ul>
            <h3 className="text-2xl pt-6">
              Payment, Refunds, Upgrading and Downgrading Terms
            </h3>
            <p className="pt-2">
              All paid plans must enter a valid payment account once the free
              trial period has expired.
            </p>
            <p className="pt-4">
              For monthly payment plans, The Service is billed in advance on a
              monthly basis and is non-refundable. There will be no refunds or
              credits for partial months of service, or refunds for months
              unused with an open account. In order to treat everyone equally,
              no exceptions will be made.
            </p>
            <p className="pt-4">
              All fees are exclusive of all taxes, levies, or duties imposed by
              taxing authorities, and you shall be responsible for payment of
              all such taxes, levies, or duties.
            </p>
            <h3 className="text-2xl pt-6">Cancellation and Termination</h3>
            <p className="pt-2">
              You are solely responsible for properly canceling your account. We
              require that you contact Us directly to cancel your account so
              that We can be sure you have any data you need prior to deletion.
              All of your Content will be immediately deleted from The Service
              upon cancellation, and any of your data that you request will be
              transferred to you electronically. If provincial/state regulations
              require that this data be stored for a period of time, you will
              become the sole owner of that data and responsible for maintaining
              it as per provincial/state regulations. This information can not
              be recovered once your account is cancelled.
            </p>
            <p className="pt-4">
              If you cancel The Service before the end of your current paid up
              month, your cancellation will take effect immediately and you will
              not be charged again.
            </p>
            <p className="pt-4">
              We, at our sole discretion, have the right to suspend or terminate
              your account and refuse any and all current or future use of The
              Service, or any other of our services, for any reason at any time.
              Such termination of The Service will result in the deactivation or
              deletion of your Account or your access to your Account, and the
              forfeiture and relinquishment of all Content in your Account. We
              reserve the right to refuse service to anyone for any reason at
              any time.
            </p>
            <h3 className="text-2xl pt-6">
              Modifications to The Service and Prices
            </h3>
            <p className="pt-2">
              We reserve the right at any time and from time to time to modify
              or discontinue, temporarily or permanently, The Service (or any
              part thereof) with or without notice.
            </p>
            <p className="pt-4">
              Prices of all Services, including but not limited to monthly
              subscription plan fees to The Service, are subject to change upon
              30 days notice from The Company. Such notice may be provided at
              any time by posting the changes to the Site or The Service itself.
            </p>
            <p className="pt-4">
              We shall not be liable to you or to any third-party for any
              modification, price change, suspension or discontinuance of The
              Service.
            </p>
            <h3 className="text-2xl pt-6">Copyright and Content Ownership</h3>
            <p className="pt-2">
              We do not pre-screen Content, but We and our designees have the
              right (but not the obligation) in our sole discretion to refuse or
              remove any Content that is available via The Service.
            </p>
            <p className="pt-4">
              You shall defend The Company against any claim, demand, suit or
              proceeding made or brought against The Company by a third-party
              alleging that Your Content, or Your use of The Service in
              violation of this Agreement, infringes or misappropriates the
              intellectual property rights of a third-party or violates
              applicable law, and shall indemnify The Company for any damages
              finally awarded against, and for reasonable attorney’s fees
              incurred by The Company in connection with any such claim, demand,
              suit or proceeding; provided, that We (a) promptly give You
              written notice of the claim, demand, suit or proceeding; (b) give
              You sole control of the defense and settlement of the claim,
              demand, suit or proceeding (provided that You may not settle any
              claim, demand, suit or proceeding unless the settlement
              unconditionally releases The Company of all liability); and (c)
              provides to You all reasonable assistance, at Your expense.
            </p>
            <p className="pt-4">
              The look and feel of The Service is copyright of The Company. All
              rights reserved. You may not duplicate, copy, or reuse any portion
              of the HTML/CSS, Javascript, or visual design elements or concepts
              without express written permission from The Company.
            </p>
            <h3 className="text-2xl pt-6">General Conditions</h3>
            <p className="pt-2">
              Your use of The Service is at your sole risk. The service is
              provided on an "as is" and "as available" basis.
            </p>
            <p className="pt-4">
              Support for our services is only available in English, via email.
            </p>
            <p className="pt-4">
              You understand that We use third-party vendors and hosting
              partners to provide the necessary hardware, software, networking,
              storage, and related technology required to run The Service.
            </p>
            <p className="pt-4">
              You must not modify, adapt or hack The Service or modify another
              website so as to falsely imply that it is associated with The
              Service, or any Service/Website provided by The Company.
            </p>
            <p className="pt-4">
              You agree not to reproduce, duplicate, copy, sell, resell or
              exploit any portion of The Service, use of The Service, or access
              to The Service without the express written permission from The
              Company.
            </p>
            <p className="pt-4">
              We may, but have no obligation to, remove Content and Accounts
              containing Content that We determine in our sole discretion are
              unlawful, offensive, threatening, libelous, defamatory,
              pornographic, obscene or otherwise objectionable or violates any
              party's intellectual property or these Terms of Service.
            </p>
            <p className="pt-4">
              Verbal, physical, written or other abuse (including threats of
              abuse or retribution) of any customer, employee, member, or
              officer will result in immediate account termination.
            </p>
            <p className="pt-4">
              You understand that the technical processing and transmission of
              The Service, including your Content, may be transferred
              unencrypted and involve (a) transmissions over various networks;
              and (b) changes to conform and adapt to technical requirements of
              connecting networks or devices.
            </p>
            <p className="pt-4">
              You must not upload, post, host, or transmit unsolicited email,
              SMSs, or "spam" messages.
            </p>
            <p className="pt-4">
              You must not transmit any worms or viruses or any code of a
              destructive nature.
            </p>
            <p className="pt-4">
              We do not warrant that (i) The Service will meet your specific
              requirements, (ii) The Service will be uninterrupted, timely,
              secure, or error-free, (iii) the results that may be obtained from
              the use of The Service will be accurate or reliable, (iv) the
              quality of any products, services, information, or other material
              purchased or obtained by you through The Service will meet your
              expectations, and (v) any errors in The Service will be corrected.
            </p>
            <p className="pt-4">
              We do not guarantee that data (including photos) will be stored
              for any specific period of time. Photos may be deleted at our
              discretion if We so require.
            </p>
            <p className="pt-4">
              You expressly understand and agree that We shall not be liable for
              any direct, indirect, incidental, special, consequential or
              exemplary damages, including but not limited to, damages for loss
              of profits, goodwill, use, data or other intangible losses (even
              if We have been advised of the possibility of such damages),
              resulting from: (i) the use or the inability to use The Service;
              (ii) the cost of procurement of substitute goods and services
              resulting from any goods, data, information or services purchased
              or obtained or messages received or transactions entered into
              through or from The Service; (iii) unauthorized access to or
              alteration of your transmissions or data; (iv) statements or
              conduct of any third-party on The Service; (v) or any other matter
              relating to The Service.
            </p>
            <p className="pt-4">
              The failure of The Company to exercise or enforce any right or
              provision of the Terms of Service shall not constitute a waiver of
              such right or provision. The Terms of Service constitutes the
              entire agreement between you and The Company and govern your use
              of The Service, superseding any prior agreements between you and
              The Company (including, but not limited to, any prior versions of
              the Terms of Service). You agree that these Terms of Service and
              Your use of The Service are governed under Alberta law.
            </p>
            <p className="pt-4">
              KidGenius acts as a data storage and communications platform for
              enabling the connection between Parents and Child Care Providers.
              We do not screen or censor the data Child Care Providers input
              into the system. All users including both Parent and Child Care
              Providers do hereby represent, understand and expressly agree that
              We do not have control over the quality, timing, safety, legality
              or any other aspect whatsoever of the truth or accuracy of the
              information posted, the services actually delivered by the Child
              Care Providers, nor the integrity, or responsibility for any of
              the actions whatsoever of the Parents.
            </p>
            <p className="pt-4">
              Further, We make no representations or warranties as to the online
              availability of its website and database. We will not be
              responsible in any way for the availability of the website
              services and information.
            </p>
            <p className="pt-4">
              We will not moderate any information posted by any User on the
              Website except for circumstances where information is drawn to the
              attention of The Company as inappopriate by a User.
            </p>
            <p className="pt-4">
              The Child Care Provider releases The Company, its successors and
              assigns, as well as its officers and agents, from all actions,
              suits, claims, demands and causes of action whatsoever at law, in
              equity and under statute which they may have, or but for this
              Agreement would or might at any time hereafter have or have had
              against The Company in respect of, arising out of or resulting
              from the actions of The Company or the release of the Providers's
              personal information on the Website.
            </p>
            <p className="pt-4">
              The Child Care Providers agree that the We shall not be liable to
              the Provider or to any other person, for incidental or
              consequential losses, damages, or expenses, directly or indirectly
              arising from any action or omission by either a Parent, an Agency
              or The Company.
            </p>
            <p className="pt-4">
              The Provider acknowledges that under no circumstances shall The
              Company be liable for the Providers's fees.
            </p>
            <h3 className="text-2xl pt-6">API Terms</h3>
            <p className="pt-2">
              Should We choose to provide an API (Application Program
              Interface), customers may access some of their data from The
              Service via an API. Any use of the API, including use of the API
              through a third-party product that accesses The Service, is bound
              by these Terms of Service plus the following specific terms:
            </p>
            <ul className="list-decimal pt-4 pl-6">
              <li>
                You expressly understand and agree that We shall not be liable
                for any direct, indirect, incidental, special, consequential or
                exemplary damages, including but not limited to, damages for
                loss of profits, goodwill, use, data or other intangible losses
                (even if We have been advised of the possibility of such
                damages), resulting from your use of the API or third-party
                products that access data via the API.
              </li>
              <li>
                Abuse or excessively frequent requests to The Service via the
                API may result in the temporary or permanent suspension of your
                account's access to the API. The company, in its sole
                discretion, will determine abuse or excessive usage of the API.
                The company will make a reasonable attempt via email to warn the
                account owner prior to suspension.
              </li>
              <li>
                We reserve the right at any time to modify or discontinue,
                temporarily or permanently, your access to the API (or any part
                thereof) with or without notice.
              </li>
            </ul>
          </div>
        </div>
      </Pad>
    </Layout>
  );
}

export default Terms;
